import PlacementFixerLayout from './PlacementFixerLayout';

export default PlacementFixerLayout;
